import { useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Title } from 'components/Title';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';

import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
export default function KycPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [aadhar, setAadhar] = useState("");
const [pan, setPan] = useState("");
const [accountNumber, setAccountNumber] = useState("");
const [ifsc, setIfsc] = useState("");
const [refId, setRefId] = useState(""); // store reference_id from Cashfree
const [name, setName] = useState("");
const [phone, setPhone] = useState("");
const [mobile, setMobile] = useState("");
const [memberid, setMemberid] = useState("");

const verifyDigi = async () => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_PATH}kyc/digilocker-verify`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            MobileNumber: mobile,
            memberId: memberid,
            aadharid:aadhar
        })
    });
    const data = await res.json();
    if (!res.ok) {
        alert("❌ Failed: " + (data.error || "Something went wrong"));
        return;
    }
    if (data.status === "ACCOUNT_EXISTS") {
        alert("✅ DigiLocker Verified Successfully!");
        } else {
        alert("❌ Verification Failed: " + data.status);
        const reason = encodeURIComponent("AADHAR OFFLINE DOC");
        const nextPage = `vendordocs/add?reason=${reason}`;
        app.navigate(nextPage);
    }
    } catch (error) {
    alert("❌ Network Error: " + error.message);
}
};
const verifyPAN = async () => {
    if (!pan || !name) {
        alert("Please enter pan number and name first.");
        return;
    }
    //   setLoading(true);
    try {
        const response = await fetch(`${process.env.REACT_APP_API_PATH}kyc/pan-verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pan,name,userId }),
    });
    const data = await response.json();
    console.log("Pan Verify Response:", data);
    if (data.pan_status === "VALID" || data.pan_status === "SUCCESS") {
        alert("✅ Pan Verified Successfully");
        setVerifiedData(data);
        } else {
        alert(data.message || "❌ Pan verification failed");
    }
    } catch (error) {
    console.error("Error verifying Pan:", error);
    alert("Network or server error during Aadhaar verification");
    } finally {
    //   setLoading(false);
}
};
const verifyBank = async () => {
    try {
        const response = await fetch(
        `${process.env.REACT_APP_API_PATH}kyc/bank-verify`,
        {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                token: localStorage.getItem("token") // include auth token if required
            },
            body: JSON.stringify({
                bank_account: accountNumber,
                ifsc: ifsc,
                name: name,
                phone: phone,
                userId: userId
            })
        }
        );
        const data = await response.json();
        console.log("Account Verify Response:", data);
        if (!response.ok) {
            alert(data.message || "❌ Verification failed");
            return;
        }
        // SUCCESS CONDITIONS (Cashfree)
        const status = data.account_status?.toUpperCase();
        if (status === "VALID" || status === "SUCCESS" || status === "ACCOUNT_IS_VALID") {
            alert("✅ Account Verified Successfully");
            setVerifiedData(data);
            return;
        }
        // FAILED CONDITIONS
        alert(data.message || "❌ Account verification failed");
        } catch (err) {
        console.error("Bank verify error:", err);
        alert("Something went wrong, please try again");
    }
};

	return (
		<main id="KycPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="kyc"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <Card title="KYC Verification Form" className="p-4 max-w-2xl mx-auto">
                    {/* Aadhaar Section */}
                    <div className="p-fluid grid align-items-center mb-3">

                             <div className="col-12 md:col-4">
                                 <label htmlFor="aadhar">Member ID</label>
                                                <DataSource   apiPath="components_data/memberid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="memberid"  onClick={setMemberid}   optionLabel="label" optionValue="value"  value={memberid}  options={response}   onChange={(e) => setMemberid(e.value)}  label="Member ID"  placeholder="Select Member.."  className=""   />
                                                    {/* <ErrorMessage name="memberid" component="span" className="p-error" /> */}
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>

                        <div className="col-12 md:col-4">
                            <label htmlFor="aadhar">Aadhaar Number</label>
                            <InputText
                            id="aadhar"
                            value={aadhar}
                            onChange={(e) => setAadhar(e.target.value)}
                            placeholder="Enter Aadhaar"
                            />
                        </div>
                           <div className="col-12 md:col-4">
                                    <label htmlFor="phone">Mobile</label>
                                    <InputText
                                    id="mobile"
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                    placeholder="Enter Mobile Number"
                                    />
                                </div>

                        <div className="col-12 md:col-2 flex align-items-end">
                            <Button label="Verify" onClick={verifyDigi} className="p-button-success w-full" />
                        </div>
                    </div>
                    <Divider />
                        {/* PAN Section */}
                        <div className="p-fluid grid align-items-center mb-3">
                            <div className="col-12 md:col-4">
                                <label htmlFor="pan">PAN Card Number</label>
                                <InputText
                                id="pan"
                                value={pan}
                                onChange={(e) => setPan(e.target.value.toUpperCase())}
                                placeholder="Enter PAN"
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label htmlFor="name">Name</label>
                                <InputText
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter Name"
                                />
                            </div>
                            <div className="col-12 md:col-4 flex align-items-end">
                                <Button label="Verify" onClick={verifyPAN} className="p-button-success w-full" />
                            </div>
                        </div>
                        <Divider />
                            {/* Bank Section */}
                            <div className="p-fluid grid align-items-center mb-3">
                                <div className="col-12 md:col-4">
                                    <label htmlFor="accountNumber">Account Number</label>
                                    <InputText
                                    id="accountNumber"
                                    value={accountNumber}
                                    onChange={(e) => setAccountNumber(e.target.value)}
                                    placeholder="Enter Account Number"
                                    />
                                </div>
                                <div className="col-12 md:col-4">
                                    <label htmlFor="ifsc">IFSC Code</label>
                                    <InputText
                                    id="ifsc"
                                    value={ifsc}
                                    onChange={(e) => setIfsc(e.target.value.toUpperCase())}
                                    placeholder="Enter IFSC"
                                    />
                                </div>
                                <div className="col-12 md:col-4">
                                    <label htmlFor="name">Name</label>
                                    <InputText
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="Enter Name"
                                    />
                                </div>
                                <div className="col-12 md:col-4">
                                    <label htmlFor="phone">Phone</label>
                                    <InputText
                                    id="phone"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                    placeholder="Enter Phone Number"
                                    />
                                </div>
                                <div className="col-12 md:col-4 flex align-items-end">
                                    <Button label="Verify" onClick={verifyBank} className="p-button-success w-full" />
                                </div>
                            </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </section>
		</main>
	);
}
